import { Component, OnInit } from '@angular/core';
import { Meta } from '../common/seo.service';
import { FillerService } from '../common/Service_tnFiller';

@Component({
  selector: 'app-services',
  templateUrl: '../themes/default/html/services.component.html',
  styleUrls: ['../themes/default/css/services.component.scss']
})
export class ServicesComponent implements OnInit {

  infoServices: any = "";

  constructor(private myMeta: Meta, private filler: FillerService) {

    new Promise((resolve, reject) => {
      this.filler.Get_Services().subscribe(
          data => {
            this.infoServices = Object.assign([], data)
            resolve(true);
          }, err => { console.log(err) }
        );
    }).then(
      e => myMeta.setTitle(this.infoServices.Title)
    );

    
    

   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/services/services.component.ts